// Pure geometry for a minimal SVG sparkline/area chart — no charting
// library dependency (the repo has none; this keeps it that way).
// `points` is [{ ts, value }, ...] ascending by time.
export function buildSparklinePath(points, { width = 320, height = 80 } = {}) {
  if (!points || points.length < 2) {
    return null;
  }
  const values = points.map((p) => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = width / (points.length - 1);

  const coords = points.map((p, i) => {
    const x = i * stepX;
    const y = height - ((p.value - min) / range) * height;
    return [x, y];
  });

  const linePath = coords
    .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`)
    .join(" ");
  const areaPath = `${linePath} L${width.toFixed(2)},${height.toFixed(2)} L0,${height.toFixed(2)} Z`;

  return { linePath, areaPath, min, max };
}
